import Swiper from "swiper";
import { Autoplay, Navigation, EffectFade, Keyboard } from "swiper/modules";
import "uikit/dist/js/uikit.min.js";
import dragscroll from "dragscroll";

// Enable Tooltips everywhere
import Tooltip from "bootstrap/js/dist/tooltip";
var tooltipTriggerList = [].slice.call(
	document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl);
});

document.addEventListener("DOMContentLoaded", () => {
	// Fixing smooth scroll offset for anchor links
	const offset = 150;

	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			const targetId = this.getAttribute("href");
			const targetElement = document.querySelector(targetId);

			if (targetElement) {
				e.preventDefault();

				const elementPosition =
					targetElement.getBoundingClientRect().top + window.pageYOffset;
				const offsetPosition = elementPosition - offset;

				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth",
				});
			}
		});
	});

	// Countdown timer logic
	const countdownEl = document.getElementById("countdown");
	if (countdownEl && countdownEl.dataset.date) {
		const targetDateStr = countdownEl.dataset.date.replace(/-/g, "/"); // Safari compatibility
		const targetDate = new Date(targetDateStr);
		function pad(num) {
			return num < 10 ? "0" + num : num;
		}
		let timer;
		function updateCountdown() {
			const now = new Date();
			const diff = targetDate - now;
			const daySpan = countdownEl.querySelector(".countdown_day");
			const hourSpan = countdownEl.querySelector(".countdown_hour");
			const minuteSpan = countdownEl.querySelector(".countdown_minute");
			const secondSpan = countdownEl.querySelector(".countdown_second");
			const messageEl = document.getElementById("countdown-message");
			if (diff <= 0) {
				if (daySpan) daySpan.textContent = "00";
				if (hourSpan) hourSpan.textContent = "00";
				if (minuteSpan) minuteSpan.textContent = "00";
				if (secondSpan) secondSpan.textContent = "00";
				if (messageEl) messageEl.textContent = "NASH Cup is live!";
				clearInterval(timer);
				return;
			}
			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
			const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((diff / (1000 * 60)) % 60);
			const seconds = Math.floor((diff / 1000) % 60);
			if (daySpan) daySpan.textContent = pad(days);
			if (hourSpan) hourSpan.textContent = pad(hours);
			if (minuteSpan) minuteSpan.textContent = pad(minutes);
			if (secondSpan) secondSpan.textContent = pad(seconds);
		}
		updateCountdown();
		timer = setInterval(updateCountdown, 1000);
	}

	// Sponsors carousel
	const carouselEl = document.querySelector(".sponsors-carousel");
	if (carouselEl) {
		const swiper = new Swiper(carouselEl, {
			modules: [Autoplay, Navigation],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 850,
			slidesPerView: 1,
			spaceBetween: 30,
			centeredSlides: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 60,
				},
				1680: {
					slidesPerView: 5,
					spaceBetween: 60,
				},
			},
		});
	}

	// Stream carousel
	const streamCarouselEl = document.querySelector(".stream-carousel");
	if (streamCarouselEl) {
		const swiper = new Swiper(streamCarouselEl, {
			modules: [Navigation],
			loop: true,
			speed: 850,
			slidesPerView: 1,
			spaceBetween: 30,
			centeredSlides: true,
			navigation: {
				nextEl: ".stream-swiper-button-next",
				prevEl: ".stream-swiper-button-prev",
			},
			breakpoints: {
				768: {
					initialSlide: 1,
					slidesPerView: 2,
				},
				1200: {
					initialSlide: 1,
					slidesPerView: 3,
				},
			},
		});
	}

	// Stream Modal
	const videoModal = document.getElementById("videoModal");
	const modalTitle = document.getElementById("videoTitle");
	const modalInner = document.getElementById("videoModalInner");

	videoModal.addEventListener("show.bs.modal", function (event) {
		const trigger = event.relatedTarget;
		const videoTitle = trigger.getAttribute("data-video-title") || "";
		let embed = trigger.getAttribute("data-embed");

		// Remove width and height attributes
		embed = embed.replace(/\s(width|height)="\d*"/gi, "");

		// Add autoplay if YouTube
		if (embed.includes("youtube.com/embed")) {
			embed = embed.replace(/src="([^"]+)"/, function (match, src) {
				const url = new URL(src, window.location.origin);
				url.searchParams.set("autoplay", "1");
				return `src="${url.toString()}"`;
			});
		}

		// Wrap in responsive Bootstrap ratio
		modalInner.innerHTML = `<div class="ratio ratio-16x9">${embed}</div>`;
		modalTitle.textContent = videoTitle;
	});

	videoModal.addEventListener("hidden.bs.modal", function () {
		modalInner.innerHTML = ""; // stop video
		modalTitle.textContent = "";
	});
});

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	var svgOpen =
		'<div class="dropdown-trigger position-absolute top-50 end-0 translate-middle d-xl-none text-center lh-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#1E3962" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></div>';
	$("#main-nav .menu-item.dropdown").each(function () {
		// Appends the dropdown arrow
		$(this).append(svgOpen);
	});
	$("#main-nav .menu-item .dropdown-trigger").click(function () {
		// Toggles the dropdown
		$(this).siblings(".dropdown-menu").toggleClass("show");
	});

	//  Ensure the first .tab-pane has .active and .show classes inside .block-tabs, then hide the #tabLoader
	$(".block-tabs").each(function () {
		$(this).find(".tab-pane").first().addClass("active show");
		$(this).find("#tabLoader").hide();
	});

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100"
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100"
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100"
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100"
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100"
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100"
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100"
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100"
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100"
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100"
	);

	// if .btn-arrow, add the arrow icon at the end of the <a> element inside the button
	$(".btn-arrow").each(function () {
		const anchor = $(this).find("a");
		if (anchor.length && !anchor.find("svg").length) {
			anchor.append(
				'<svg class="ms-3" width="16" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 10.0455C0 9.74947 0.0978251 9.46561 0.271955 9.25632C0.446085 9.04703 0.682255 8.92945 0.928512 8.92945H22.8284L16.9843 1.90755C16.81 1.69799 16.712 1.41377 16.712 1.11741C16.712 0.821058 16.81 0.536839 16.9843 0.327283C17.1587 0.117727 17.3952 6.98241e-09 17.6417 0C17.8883 -6.98241e-09 18.1248 0.117727 18.2991 0.327283L25.7272 9.25532C25.8137 9.35899 25.8823 9.48214 25.9291 9.61773C25.9759 9.75331 26 9.89866 26 10.0455C26 10.1922 25.9759 10.3376 25.9291 10.4732C25.8823 10.6088 25.8137 10.7319 25.7272 10.8356L18.2991 19.7636C18.1248 19.9732 17.8883 20.0909 17.6417 20.0909C17.3952 20.0909 17.1587 19.9732 16.9843 19.7636C16.81 19.5541 16.712 19.2699 16.712 18.9735C16.712 18.6771 16.81 18.3929 16.9843 18.1834L22.8284 11.1615H0.928512C0.682255 11.1615 0.446085 11.0439 0.271955 10.8346C0.0978251 10.6253 0 10.3414 0 10.0455Z" fill="white"/></svg>'
			);
		}
	});

	// toTopButton
	if ($("#toTopButton").length) {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 600) {
				$("#toTopButton").removeClass("hidden");
			} else {
				$("#toTopButton").addClass("hidden");
			}
		});
		// Smoothly scroll back to top when the button is clicked
		$("#toTopButton").on("click", function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
});
